module.exports = __webpack_public_path__ + "img/achievement_6.0377fb08.png";